<template>
  <Body class="page-view page-review-view" />

  <!-- post header -->
  <section class="section post-header">
    <!-- <div v-if="review?.isMine" class="wrap post-status">
      <div v-if="!review?.openYn" class="status waiting">
        {{ $t('아직접수전이에요자유롭게수정할수있어요') }}
      </div>
      <div v-if="false" class="status checking">
        {{ $t('확인중이에요내용은수정할수없어요') }}
      </div>
      <div v-if="review?.openYn" class="status open">
        {{ $t('공개되었어요내용은수정할수없어요') }}
      </div>
    </div> -->

    <!-- auto translate -->
    <div v-if="review?.autoTransYn" class="wrap auto-translate">
      <div class="translate-guide">
        {{ $t('이글은자동번역되었어요') }} {{ $t('번역이어색하거나원글과다소다를수있어요') }}
      </div>
    </div>

    <div class="wrap">
      <div class="category-wrap">
        <span
          v-for="category in review?.categories"
          :key="category"
          class="category"
          :class="review?.categories.map((c) => categoryStyle[category])"
        >{{ $t(categories?.find((c) => category === c.id)?.name ?? '') }}</span>
      </div>
      <h1 class="post-title">
        {{ review?.title }}
      </h1>
      <div class="post-info">
        <div class="user">
          <div class="profile-photo" :style="{ backgroundImage: `url(${profileImageUrl})` }" />
          <div class="username">
            {{ review?.writerNm }}, {{ review?.countryNm }}
          </div>
        </div>
        <div class="detail">
          <div v-if="review?.createdAt" class="date">
            {{ formatIntlDate(new Date(review?.createdAt), locale) }}
          </div>
          <div v-if="review?.openYn" class="view">
            <i class="ico ico-smile" />{{ formatNumber(review?.viewCnt ?? 0, locale) }}
          </div>
          <div v-if="review?.openYn" class="comment">
            <i class="ico ico-reply" />{{ formatNumber(review?.commentCnt ?? 0, locale) }}
          </div>
          <div v-if="review?.openYn" class="like">
            <i class="ico ico-heart-round" />{{ formatNumber(review?.likeCnt ?? 0, locale) }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- photo slide -->
  <section v-if="review && review.images.length > 0" class="section photo-slide">
    <div class="wrap">
      <ClientOnly>
        <Swiper
          :modules="[Pagination, Autoplay]"
          :slides-per-view="1"
          :space-between="8"
          :autoplay="false"
          :auto-height="true"
          :pagination="{ el: '.photo-slide .wrap .dots', clickable: true }"
        >
          <SwiperSlide v-for="image in review?.images" :key="image.docFileId">
            <div class="item">
              <img :src="image.url" alt="">
            </div>
          </SwiperSlide>
        </Swiper>
        <div class="dots" />
      </ClientOnly>
    </div>
  </section>

  <!-- peacemaker 활동 정보 신규 추가 -->
  <div v-if="review?.peacemaker" class="section post-peacekmaker">
    <div class="wrap">
      <div class="peacekmaker-info">
        <h2 class="title">
          <div v-html="$t('spanclasscolor우리는피스메이커span활동정보')" />
        </h2>
        <ul class="detail">
          <li class="item">
            <div class="label">
              {{ $t('활동') }}
            </div>
            <div class="con">
              {{ $t(review?.peacemaker.categoryName ?? '') }}
            </div>
          </li>
          <template v-if="review?.peacemaker.categoryId === 10">
            <li class="item">
              <div class="label">
                {{ $t('선언일') }}
              </div>
              <div class="con">
                {{ formatIntlDate(new Date(review?.peacemaker.activityDt ?? ''), locale) }}
              </div>
            </li>
            <li class="item">
              <div class="label">
                {{ $t('선언공동체') }}
              </div>
              <div class="con">
                {{ (review?.peacemaker.activityPlaceTxt ?? '') || $t(review?.peacemaker.activityPlaceNm ?? '') }}
              </div>
            </li>
            <li class="item">
              <div class="label">
                {{ $t('선언인원') }}
              </div>
              <div class="con">
                {{ $t('명').replace('{}', `${review?.peacemaker.activityMember ?? 0}`) }}
              </div>
            </li>
          </template>
          <template v-else-if="review?.peacemaker.categoryId === 11">
            <li class="item">
              <div class="label">
                {{ $t('구분') }}
              </div>
              <div class="con">
                {{ $t(review?.peacemaker.materialTypeNm ?? '') }}
              </div>
            </li>
            <li class="item">
              <div class="label">
                {{ $t('공유일') }}
              </div>
              <div class="con">
                {{ formatIntlDate(new Date(review?.peacemaker.activityDt ?? ''), locale) }}
              </div>
            </li>
            <li class="item">
              <div class="label">
                {{ $t('공유기간') }}
              </div>
              <div class="con">
                {{ $t(review?.peacemaker.activityDurationNm ?? '') }}
              </div>
            </li>
            <li class="item">
              <div class="label">
                {{ $t('공유장소') }}
              </div>
              <div class="con">
                {{ (review?.peacemaker.activityPlaceTxt ?? '') || $t(review?.peacemaker.activityPlaceNm ?? '') }}
              </div>
            </li>
            <li class="item">
              <div class="label">
                {{ $t('동참인원') }}
              </div>
              <div class="con">
                {{ $t('명').replace('{}', `${review?.peacemaker.activityMember ?? 0}`) }}
              </div>
            </li>
          </template>
          <template v-else-if="review?.peacemaker.categoryId === 12">
            <li class="item">
              <div class="label">
                {{ $t('활동일') }}
              </div>
              <div class="con">
                {{ formatIntlDate(new Date(review?.peacemaker.activityDt ?? ''), locale) }}
              </div>
            </li>
            <li class="item">
              <div class="label">
                {{ $t('활동장소') }}
              </div>
              <div class="con">
                {{ review?.peacemaker.activityPlaceTxt }}
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>

  <!-- post contents -->
  <div class="section post-contents">
    <div class="wrap">
      <!-- content -->
      <div class="contents-container" v-html="review?.contents" />

      <!-- rights -->
      <div class="rights">
        {{ $t('무단전재및재배포금지') }}
      </div>

      <!-- likes -->
      <div v-if="review?.openYn" class="like-wrap">
        <button type="button" class="btn-like" @click="onClickLikeButton">
          <ClientOnly>
            <Vue3Lottie
              ref="lottie"
              :animation-data="likeJSON"
              :speed="1"
              :auto-play="false"
              :loop="false"
              @on-animation-loaded="onAnimationLoaded"
            />
          </ClientOnly>
        </button>
        <div class="like-count">
          {{ formatNumber(review?.likeCnt ?? 0, locale) }}
        </div>
      </div>

      <!-- sns -->
      <!-- <ul class="post-sns">
        <li class="kakaotalk" onclick="shareKatalk();">
          <a href=""><span class="blind">카카오톡</span></a>
        </li>
        <li class="facebook">
          <a
            href=""
            title="Facebook"
            rel="nofollow noopener"
            target="_blank"
            onclick="shareOnFacebook(event)"
          >
            <span class="blind">페이스북</span>
          </a>
        </li>
        <li class="x">
          <a
            href="#"
            title="X"
            rel="nofollow noopener"
            target="_blank"
            onclick="shareOnX(event)"
          >
            <span class="blind">X</span>
          </a>
        </li>
        <li class="sms">
          <a
            href="#"
            title="SMS"
            rel="nofollow noopener"
            onclick="shareViaSMS(event)"
          >
            <span class="blind">문자메시지</span>
          </a>
        </li>
      </ul> -->

      <div class="btns">
        <a class="btn" @click="$router.back()">{{ $t('뒤로가기') }}</a>
        <!-- <NuxtLink class="btn" :to="$localePath(`/review?${queryString}`)">{{ $t('뒤로가기') }}</NuxtLink> -->
        <NuxtLink v-if="review?.isMine && !review?.openYn" class="btn" :to="$localePath(`/mypage/post/${id}/edit`)">
          {{
            $t('수정')
          }}
        </NuxtLink>
        <button v-if="review?.isMine" class="btn btn-delete" @click="showDeletePopup = true">
          {{ $t('삭제') }}
        </button>
      </div>
    </div>
  </div>

  <!-- comment -->
  <div v-if="review?.openYn === true && commentToken" class="section">
    <div class="wrap">
      <Comment
        :comment-token="commentToken"
        :best-comments="review.bestComments"
        :admin-comments="review.adminComments"
      />
    </div>
  </div>

  <!-- related -->
  <div v-if="review?.openYn" class="section">
    <!-- lists -->
    <div class="wrap">
      <ul class="lists list-lateral related">
        <li v-if="review?.prev" class="list-item">
          <NuxtLink :to="$localePath(`/review/${review?.prev.id}?${queryString}`)" class="list-link">
            <div class="thum" :class="{ default: review?.prev.thumbnailUrl == null }">
              <div
                class="thum-img"
                :style="{ backgroundImage: `url(${review?.prev.thumbnailUrl ?? defaultThumbnail})` }"
              />
            </div>
            <div class="info">
              <div class="label prev">
                <i class="ico ico-arrow-left" /> {{ $t('이전글') }}
              </div>
              <div class="post-title">
                {{ review?.prev.title }}
              </div>
              <div class="post-info">
                <span class="user">{{ review?.prev.writerNm }}, {{ review?.prev.countryNm }}</span>
              </div>
            </div>
          </NuxtLink>
        </li>
        <li v-if="review?.next" class="list-item">
          <NuxtLink :to="$localePath(`/review/${review?.next.id}?${queryString}`)" class="list-link">
            <div class="thum" :class="{ default: review?.next.thumbnailUrl == null }">
              <div
                class="thum-img"
                :style="{ backgroundImage: `url(${review?.next.thumbnailUrl ?? defaultThumbnail})` }"
              />
            </div>
            <div class="info">
              <div class="label next">
                {{ $t('다음글') }} <i class="ico ico-arrow-right" />
              </div>
              <div class="post-title">
                {{ review?.next.title }}
              </div>
              <div class="post-info">
                <span class="user">{{ review?.next.writerNm }}, {{ review?.next.countryNm }}</span>
              </div>
            </div>
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>

  <DeletePopup v-if="showDeletePopup" @on-close-click="showDeletePopup = false" @on-delete-click="onDeleteClick" />
</template>

<script lang="ts" setup>
import { Autoplay, Pagination } from 'swiper/modules'
// Swiper Slide
import { Swiper, SwiperSlide } from 'swiper/vue'
// lottie
import { Vue3Lottie } from 'vue3-lottie'
import likeJSON from '@/assets/lotties/like.json'
import 'swiper/css'

import 'swiper/css/autoplay'
import 'swiper/css/pagination'

const { $t } = useNuxtApp()
const { locale } = useI18n()
const route = useRoute()
const queryString = route.fullPath.split('?')[1] ?? ''

const { isLoggedIn, showLoginPopup } = useAuth()

// 후기
const id = computed(() => Number(route.params.id))
const countryCd = computed(() => (route.query.countryCd as string) || undefined)
const category = computed(() => Number(route.query.category ?? 0))
const {
  fetchCategories,
  fetchReview,
  categoryStyle,
  updateReviewViewCnt,
  fetchReviewCommentToken,
  toggleReviewLike,
} = useReview()

const { data: review, refresh } = await fetchReview(id, {
  countryCd,
  category,
})
if (!review.value || review.value?.openYn === false) {
  navigateTo('/review')
  // throw new Error('Review not found')
}

const lottie = ref<any>(null)

// head
useHead({
  title: `${review.value?.title} - ${$t('어머니사랑과평화의날캠페인')}`, // 글 제목 - 사이트명
  link: [
    { rel: 'stylesheet', href: `/css/review.css?${useBuildTime()}` },
    { rel: 'stylesheet', href: 'https://pic.watv.org/watveditor/watvEditor@next.css' },
  ],
})

const result = await updateReviewViewCnt(id.value)
if (result === 'success') {
  review.value!.viewCnt++
}

// 뒤로가기(목록필터 유지)
// const listFilterCookie = useCookie<{ route: string, query: string }>('HMLReviewListFilter', {
//   expires: tomorrow,
//   default: () => ({ route: '/review', query: '' }),
// })

// 카테고리
const categories = await fetchCategories([2, 9])
// 프로필 사진
const { fetchProfileImages } = useProfile()
const { data: profileImages } = await fetchProfileImages([review.value!.createdUid])
const profileImageUrl = computed(
  () => profileImages.value?.find((p: any) => p.id === review.value!.createdUid)?.url ?? '',
)

// 코멘트 토큰 발급
const { data: commentToken } = await fetchReviewCommentToken(review.value!.id)

// 삭제
const showDeletePopup = ref(false)
const { deleteReview } = useReview()
async function onDeleteClick() {
  await deleteReview(id.value)
  navigateTo('/review')
}

// 썸네일
const { defaultThumbnail } = useReview()

onMounted(() => {
  const editor = (window as any).WatvEditorViewer
  editor.view('.contents-container')
})

function onAnimationLoaded(_: any) {
  if (review.value?.isLiked) {
    const duration = lottie.value.getDuration()
    lottie.value.goToAndStop(duration)
  }
}

async function onClickLikeButton() {
  const reviewId = review.value?.id
  if (!reviewId)
    return

  if (!isLoggedIn.value) {
    showLoginPopup()
    return
  }

  const isLiked = review.value?.isLiked

  if (isLiked) {
    lottie.value.goToAndStop(0)
  }
  else {
    lottie.value.goToAndPlay(20)
  }

  await toggleReviewLike(reviewId)

  refresh()
}
</script>
